
export default {
  data() {
    return {
      categoryData:{
        "huandeng": {
          "id": "1329357285870346241",
          "categoryIndex": "huandeng",
          "categoryPinyin": "huandeng",
          "categoryTitle": "幻灯",
          "leaf": "1",
          "children": [],
          "url": "html/web/huandeng/index.html?type=1"
        },
        "gxxm": {
          "id": "1668187970511384577",
          "categoryIndex": "gxxm",
          "categoryPinyin": "gxxm",
          "categoryTitle": "公益项目",
          "leaf": "0",
          "children": [
            {
              "id": "1668188132696731649",
              "categoryIndex": "zhengfuweituo",
              "categoryPinyin": "zhengfuweituo",
              "categoryTitle": "政府委托",
              "leaf": "1",
              "children": [],
              "url": "html/web/gxxm/zhengfuweituo/index.html?type=1"
            },
            {
              "id": "1668188254159581185",
              "categoryIndex": "shehuijuanzeng",
              "categoryPinyin": "shehuijuanzeng",
              "categoryTitle": "社会捐赠",
              "leaf": "0",
              "children": [
                {
                  "id": "1668191050019713025",
                  "categoryIndex": "shehuijuanzengxiangmu",
                  "categoryPinyin": "shehuijuanzengxiangmu",
                  "categoryTitle": "社会捐赠项目",
                  "leaf": "1",
                  "children": [],
                  "url": "html/web/gxxm/shehuijuanzeng/shehuijuanzengxiangmu/index.html?type=1"
                }
              ]
            },
            {
              "id": "1668188371868528642",
              "categoryIndex": "gaoxiaogongmu",
              "categoryPinyin": "gaoxiaogongmu",
              "categoryTitle": "高校公募",
              "leaf": "1",
              "children": [],
              "url": "html/web/gxxm/gaoxiaogongmu/index.html?type=1"
            },
            {
              "id": "1668188496921702401",
              "categoryIndex": "pinpaixiangmu",
              "categoryPinyin": "pinpaixiangmu",
              "categoryTitle": "品牌项目",
              "leaf": "1",
              "children": [],
              "url": "html/web/gxxm/pinpaixiangmu/index.html?type=1"
            }
          ]
        },
        "djgz": {
          "id": "1668187264064761858",
          "categoryIndex": "djgz",
          "categoryPinyin": "djgz",
          "categoryTitle": "党建工作",
          "leaf": "0",
          "children": [
            {
              "id": "1668187520877801474",
              "categoryIndex": "dangjianzuzhi",
              "categoryPinyin": "dangjianzuzhi",
              "categoryTitle": "党建组织",
              "leaf": "1",
              "children": [],
              "url": "html/web/djgz/dangjianzuzhi/index.html?type=1"
            },
            {
              "id": "1668187881340481537",
              "categoryIndex": "dangjianxinxidongtai",
              "categoryPinyin": "dangjianxinxidongtai",
              "categoryTitle": "党建信息动态",
              "leaf": "1",
              "children": [],
              "url": "html/web/djgz/dangjianxinxidongtai/index.html?type=1"
            }
          ]
        },
        "wysq": {
          "id": "1668188918600249346",
          "categoryIndex": "wysq",
          "categoryPinyin": "wysq",
          "categoryTitle": "我要申请",
          "leaf": "0",
          "children": [
            {
              "id": "1668189127610806273",
              "categoryIndex": "zhuxuezhujiao1",
              "categoryPinyin": "zhuxuezhujiao1",
              "categoryTitle": "助学助教",
              "leaf": "1",
              "children": [],
              "url": "html/web/wysq/zhuxuezhujiao1/index.html?type=1"
            },
            {
              "id": "1668189272276545538",
              "categoryIndex": "jiankangjiaoyu1",
              "categoryPinyin": "jiankangjiaoyu1",
              "categoryTitle": "健康教育",
              "leaf": "1",
              "children": [],
              "url": "html/web/wysq/jiankangjiaoyu1/index.html?type=1"
            },
            {
              "id": "1668189423963549697",
              "categoryIndex": "yingjijiuzai1",
              "categoryPinyin": "yingjijiuzai1",
              "categoryTitle": "应急救灾",
              "leaf": "1",
              "children": [],
              "url": "html/web/wysq/yingjijiuzai1/index.html?type=1"
            },
            {
              "id": "1668189610228396034",
              "categoryIndex": "xiangcunzhenxing",
              "categoryPinyin": "xiangcunzhenxing",
              "categoryTitle": "乡村振兴",
              "leaf": "1",
              "children": [],
              "url": "html/web/wysq/xiangcunzhenxing/index.html?type=1"
            },
            {
              "id": "1668190029482635266",
              "categoryIndex": "zhongguojiaoyufazhanjijinhuizhuxuejihua",
              "categoryPinyin": "zhongguojiaoyufazhanjijinhuizhuxuejihua",
              "categoryTitle": "中国教育发展基金会助学计划",
              "leaf": "1",
              "children": [],
              "url": "html/web/wysq/zhongguojiaoyufazhanjijinhuizhuxuejihua/index.html?type=1"
            }
          ]
        },
        "gywm": {
          "id": "1584795942171246594",
          "categoryIndex": "gywm",
          "categoryPinyin": "gywm",
          "categoryTitle": "关于我们",
          "leaf": "0",
          "children": [
            {
              "id": "1668166824558669826",
              "categoryIndex": "jibenxinxi",
              "categoryPinyin": "jibenxinxi",
              "categoryTitle": "基本信息",
              "leaf": "0",
              "children": [
                {
                  "id": "1668167833129398274",
                  "categoryIndex": "zhangcheng",
                  "categoryPinyin": "zhangcheng",
                  "categoryTitle": "章程",
                  "leaf": "1",
                  "children": [],
                  "url": "html/web/gywm/jibenxinxi/zhangcheng/index.html?type=1"
                },
                {
                  "id": "1668193614933078017",
                  "categoryIndex": "jijinhuijianjie",
                  "categoryPinyin": "jijinhuijianjie",
                  "categoryTitle": "基金会简介",
                  "leaf": "1",
                  "children": [],
                  "url": "html/web/gywm/jibenxinxi/jijinhuijianjie/index.html?type=1"
                },
                {
                  "id": "1668169162555994113",
                  "categoryIndex": "lishihui",
                  "categoryPinyin": "lishihui",
                  "categoryTitle": "理事会",
                  "leaf": "1",
                  "children": [],
                  "url": "html/web/gywm/jibenxinxi/lishihui/index.html?type=1"
                },
                {
                  "id": "1668169520657281026",
                  "categoryIndex": "farendengjizhengshu",
                  "categoryPinyin": "farendengjizhengshu",
                  "categoryTitle": "法人登记证书",
                  "leaf": "1",
                  "children": [],
                  "url": "html/web/gywm/jibenxinxi/zhangcheng/index.html"
                },
                {
                  "id": "1668177722757165057",
                  "categoryIndex": "gongkaimujuanzigezhengshu",
                  "categoryPinyin": "gongkaimujuanzigezhengshu",
                  "categoryTitle": "公开募捐资格证书",
                  "leaf": "1",
                  "children": [],
                  "url": "html/web/gywm/jibenxinxi/gongkaimujuanzigezhengshu/index.html?type=1"
                },
                {
                  "id": "1668180852836216833",
                  "categoryIndex": "gongyixingjuanzengshuiqiankouchuzige",
                  "categoryPinyin": "gongyixingjuanzengshuiqiankouchuzige",
                  "categoryTitle": "公益性捐赠税前扣除资格",
                  "leaf": "1",
                  "children": [],
                  "url": "html/web/gywm/jibenxinxi/gongyixingjuanzengshuiqiankouchuzige/index.html?type=1"
                },
                {
                  "id": "1668182133084598273",
                  "categoryIndex": "feiyinglizuzhimianshuizige",
                  "categoryPinyin": "feiyinglizuzhimianshuizige",
                  "categoryTitle": "非盈利组织免税资格",
                  "leaf": "1",
                  "children": [],
                  "url": "html/web/gywm/jibenxinxi/feiyinglizuzhimianshuizige/index.html?type=1"
                }
              ]
            },
            {
              "id": "1668184195126079490",
              "categoryIndex": "zuzhijigou",
              "categoryPinyin": "zuzhijigou",
              "categoryTitle": "组织机构",
              "leaf": "1",
              "children": [],
              "url": "html/web/gywm/zuzhijigou/index.html?type=1"
            },
            {
              "id": "1588040866752204801",
              "categoryIndex": "xinxigongkai",
              "categoryPinyin": "xinxigongkai",
              "categoryTitle": "信息公开",
              "leaf": "0",
              "children": [
                {
                  "id": "1668184762653159425",
                  "categoryIndex": "zhengcefagui",
                  "categoryPinyin": "zhengcefagui",
                  "categoryTitle": "政策法规",
                  "leaf": "1",
                  "children": [],
                  "url": "html/web/gywm/xinxigongkai/zhengcefagui/index.html?type=1"
                },
                {
                  "id": "1668184952688685057",
                  "categoryIndex": "guanlizhidu",
                  "categoryPinyin": "guanlizhidu",
                  "categoryTitle": "管理制度",
                  "leaf": "1",
                  "children": [],
                  "url": "html/web/gywm/xinxigongkai/guanlizhidu/index.html?type=1"
                },
                {
                  "id": "1668185106183434241",
                  "categoryIndex": "niandugongzuobaogao",
                  "categoryPinyin": "niandugongzuobaogao",
                  "categoryTitle": "年度工作报告",
                  "leaf": "1",
                  "children": [],
                  "url": "html/web/gywm/xinxigongkai/niandugongzuobaogao/index.html?type=1"
                },
                {
                  "id": "1668185249293086721",
                  "categoryIndex": "niandushenjibaogao",
                  "categoryPinyin": "niandushenjibaogao",
                  "categoryTitle": "年度审计报告",
                  "leaf": "1",
                  "children": [],
                  "url": "html/web/gywm/xinxigongkai/niandushenjibaogao/index.html?type=1"
                },
                {
                  "id": "1584795524183687170",
                  "categoryIndex": "jjhgszq",
                  "categoryPinyin": "jjhgszq",
                  "categoryTitle": "公示专区",
                  "leaf": "0",
                  "children": [
                    {
                      "id": "1668185683877507073",
                      "categoryIndex": "juanzengmingdangongshi",
                      "categoryPinyin": "juanzengmingdangongshi",
                      "categoryTitle": "捐赠名单公示",
                      "leaf": "1",
                      "children": [],
                      "url": "html/web/gywm/xinxigongkai/jjhgszq/juanzengmingdangongshi/index.html?type=1"
                    },
                    {
                      "id": "1668186212879904769",
                      "categoryIndex": "zizhumingdangongshi",
                      "categoryPinyin": "zizhumingdangongshi",
                      "categoryTitle": "资助名单公示",
                      "leaf": "1",
                      "children": [],
                      "url": "html/web/gywm/xinxigongkai/jjhgszq/zizhumingdangongshi/index.html?type=1"
                    },
                    {
                      "id": "1668186360305496066",
                      "categoryIndex": "guanlianfanggongshi",
                      "categoryPinyin": "guanlianfanggongshi",
                      "categoryTitle": "关联方公示",
                      "leaf": "1",
                      "children": [],
                      "url": "html/web/gywm/xinxigongkai/jjhgszq/guanlianfanggongshi/index.html?type=1"
                    }
                  ]
                }
              ]
            },
            {
              "id": "1588040774389436417",
              "categoryIndex": "xinwenzhongxin",
              "categoryPinyin": "xinwenzhongxin",
              "categoryTitle": "新闻中心",
              "leaf": "0",
              "children": [
                {
                  "id": "1588041583932051457",
                  "categoryIndex": "jjhxinwenzixun",
                  "categoryPinyin": "jjhxinwenzixun",
                  "categoryTitle": "新闻资讯",
                  "leaf": "1",
                  "children": [],
                  "url": "html/web/gywm/xinwenzhongxin/jjhxinwenzixun/index.html?type=1"
                },
                {
                  "id": "1584784917548040194",
                  "categoryIndex": "jjhnews",
                  "categoryPinyin": "jjhnews",
                  "categoryTitle": "通知公告",
                  "leaf": "1",
                  "children": [],
                  "url": "html/web/gywm/xinwenzhongxin/jjhnews/index.html?type=1"
                },
                {
                  "id": "1588041776052146178",
                  "categoryIndex": "jjhgongyiaixingushi",
                  "categoryPinyin": "jjhgongyiaixingushi",
                  "categoryTitle": "公益爱心故事",
                  "leaf": "1",
                  "children": [],
                  "url": "html/web/gywm/xinwenzhongxin/jjhgongyiaixingushi/index.html?type=1"
                },
                {
                  "id": "1588042183474253826",
                  "categoryIndex": "jjhhangyefengcai",
                  "categoryPinyin": "jjhhangyefengcai",
                  "categoryTitle": "行业风采",
                  "leaf": "1",
                  "children": [],
                  "url": "html/web/gywm/xinwenzhongxin/jjhhangyefengcai/index.html?type=1"
                }
              ]
            },
            {
              "id": "1668186672231690242",
              "categoryIndex": "rongyujiangxiang",
              "categoryPinyin": "rongyujiangxiang",
              "categoryTitle": "荣誉奖项",
              "leaf": "1",
              "children": [],
              "url": "html/web/gywm/rongyujiangxiang/index.html?type=1"
            },
            {
              "id": "1668186768801345538",
              "categoryIndex": "jijinhuidashiji",
              "categoryPinyin": "jijinhuidashiji",
              "categoryTitle": "基金会大事记",
              "leaf": "1",
              "children": [],
              "url": "html/web/gywm/jijinhuidashiji/index.html?type=1"
            },
            {
              "id": "1668186840335200257",
              "categoryIndex": "lxwm",
              "categoryPinyin": "lxwm",
              "categoryTitle": "联系我们",
              "leaf": "1",
              "children": [],
              "url": "html/web/gywm/lxwm/index.html?type=1"
            }
          ]
        },
        "woyaojuankuan": {
          "id": "1665963821294497794",
          "categoryIndex": "woyaojuankuan",
          "categoryPinyin": "woyaojuankuan",
          "categoryTitle": "我要捐赠",
          "leaf": "0",
          "children": [
            {
              "id": "1666260771331977218",
              "categoryIndex": "juanzengtujing",
              "categoryPinyin": "juanzengtujing",
              "categoryTitle": "捐赠途径",
              "leaf": "0",
              "children": [
                {
                  "id": "1666261007240605698",
                  "categoryIndex": "yinhangzhanghaojuanzeng",
                  "categoryPinyin": "yinhangzhanghaojuanzeng",
                  "categoryTitle": "银行账号捐赠",
                  "leaf": "1",
                  "children": [],
                  "url": "html/web/gywm/lxwm/1668859096092766210.html"
                }
              ]
            },
            {
              "id": "1668159308600782849",
              "categoryIndex": "juanzengliucheng",
              "categoryPinyin": "juanzengliucheng",
              "categoryTitle": "捐赠流程",
              "leaf": "1",
              "children": [],
              "url": "html/web/woyaojuankuan/juanzengliucheng/index.html?type=1"
            },
            {
              "id": "1668159910344994817",
              "categoryIndex": "zhuxuezhujiao",
              "categoryPinyin": "zhuxuezhujiao",
              "categoryTitle": "助学助教",
              "leaf": "0",
              "children": [
                {
                  "id": "1668192706870456322",
                  "categoryIndex": "xiazaizhuanqu",
                  "categoryPinyin": "xiazaizhuanqu",
                  "categoryTitle": "下载专区",
                  "leaf": "1",
                  "children": [],
                  "url": "html/web/woyaojuankuan/zhuxuezhujiao/xiazaizhuanqu/index.html?type=1"
                }
              ]
            },
            {
              "id": "1668163030819090434",
              "categoryIndex": "jiankangjiaoyu",
              "categoryPinyin": "jiankangjiaoyu",
              "categoryTitle": "健康教育",
              "leaf": "1",
              "children": [],
              "url": "html/web/woyaojuankuan/jiankangjiaoyu/index.html?type=1"
            },
            {
              "id": "1668163179364560897",
              "categoryIndex": "yingjijiuzai",
              "categoryPinyin": "yingjijiuzai",
              "categoryTitle": "应急救灾",
              "leaf": "1",
              "children": [],
              "url": "html/web/woyaojuankuan/yingjijiuzai/index.html?type=1"
            },
            {
              "id": "1668163401662672897",
              "categoryIndex": "zhongguojiaoyufazhanjijinhuizhuxuejijhua",
              "categoryPinyin": "zhongguojiaoyufazhanjijinhuizhuxuejijhua",
              "categoryTitle": "中国教育发展基金会助学计划",
              "leaf": "1",
              "children": [],
              "url": "html/web/woyaojuankuan/zhongguojiaoyufazhanjijinhuizhuxuejijhua/index.html?type=1"
            }
          ]
        },
        "zyzzm": {
          "id": "1668190182859943937",
          "categoryIndex": "zyzzm",
          "categoryPinyin": "zyzzm",
          "categoryTitle": "志愿者招募",
          "leaf": "0",
          "children": [
            {
              "id": "1668190417657081857",
              "categoryIndex": "zhongguojiaoyufazhanjijinhuizhiyuanzheguanlibanfa",
              "categoryPinyin": "zhongguojiaoyufazhanjijinhuizhiyuanzheguanlibanfa",
              "categoryTitle": "中国教育发展基金会志愿者管理办法",
              "leaf": "1",
              "children": [],
              "url": "html/web/zyzzm/zhongguojiaoyufazhanjijinhuizhiyuanzheguanlibanfa/index.html?type=1"
            },
            {
              "id": "1668190552231325697",
              "categoryIndex": "zhaomutongzhi",
              "categoryPinyin": "zhaomutongzhi",
              "categoryTitle": "招募通知",
              "leaf": "1",
              "children": [],
              "url": "html/web/zyzzm/zhaomutongzhi/index.html?type=1"
            },
            {
              "id": "1668190652777181185",
              "categoryIndex": "zaixianbaoming",
              "categoryPinyin": "zaixianbaoming",
              "categoryTitle": "在线报名",
              "leaf": "1",
              "children": [],
              "url": "html/web/zyzzm/zaixianbaoming/index.html?type=1"
            }
          ]
        }
      }
    }
  },
  created() {
    this.categoryData = categoryData || this.categoryData;
  },
  mounted() {
  },
  activated() {
  },
  beforeDestroy() {
  },
  deactivated() {
  },
  methods: {
    findRoot(func){
      let path = [];
      for (const key in this.categoryData){
        const node = this.categoryData[key]
        path[0]= node ;
        if (func(node)){
          return path;
        }else if (node?.children?.length) {
          const newNode =this.findNode(node.children, func)
          if (newNode){
            path[1] = newNode;
            return path
          }
        }
      }
    },
    findNode(tree, func) {
      for (const node of tree) {
        if (func(node)) return node
        if (node?.children?.length) {
          const res = this.findNode(node.children, func)
          if (res) return res
        }
      }
      return null
    }
  }
}
